
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireab88"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireab88"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9wJdH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6efa2df7948f6795$export$6503ec6e8aabbaf; }, function (v) { return $6efa2df7948f6795$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $6efa2df7948f6795$export$f7ad0328861e2f03; }, function (v) { return $6efa2df7948f6795$export$f7ad0328861e2f03 = v; });
var $6efa2df7948f6795$export$6503ec6e8aabbaf;
var $6efa2df7948f6795$export$f7ad0328861e2f03;
"use strict";
var $6efa2df7948f6795$var$mapping = new Map();
function $6efa2df7948f6795$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6efa2df7948f6795$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6efa2df7948f6795$var$resolve(id) {
    var resolved = $6efa2df7948f6795$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6efa2df7948f6795$export$6503ec6e8aabbaf = $6efa2df7948f6795$var$register;
$6efa2df7948f6795$export$f7ad0328861e2f03 = $6efa2df7948f6795$var$resolve;

});

var $3e9284be80c92678$exports = {};

(parcelRequire("9wJdH")).register(new URL("", import.meta.url).toString(), JSON.parse('["kSOE2","index.3c4d8f8e.js","bI129","FEAST_FLEET.2fbdbd07.svg","kv6uX","icons8-veg-32.1b7d3419.png","gjAcB","icons8-non-veg-32.14536350.png","fG59c","Grocery.f0c4a440.js","4R2og","About.4deb0e5a.js"]'));


//# sourceMappingURL=index.runtime.dab6893a.js.map
